<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              TocTypeButtons(:item="item")
          .field-value(slot="n1") TT{{item.id}}
          .field-value(slot="n1") {{item.name}}
          .field-value(slot="n2") Group
          .field-value(slot="n2") {{item.group}}
          .field-value(slot="n3") Priority
          .field-value(slot="n3") {{item.priority}}

</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
  import {mapState} from 'vuex'
  import TocButtons from '../structure/ui/actions/TocButtons'
  import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'

  export default {
    name: 'TocType',
    components: {
      TocTypeButtons,
      TocButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// TocType.vue?68a775c8